<script setup lang="ts">
import { downloadDocument } from '@/components/createdUi/downloadEntityDocument'
import { SHARED_ANCHORS } from '@/modules/onboarding/scenarios/shared/anchors'

const props = withDefaults(defineProps<{
  variant?: 'ear' | 'inline'
  /** Путь ручки document/ от корня API, например `/api/ticket/ticket/1/document/` */
  path: string
  /** Имя файла без расширения, если сервер не прислал Content-Disposition */
  fallbackName: string
}>(), {
  variant: 'inline',
})

const downloadingFormat = ref<'pdf' | 'docx' | null>(null)

async function onDownload(format: 'pdf' | 'docx') {
  if (downloadingFormat.value)
    return

  downloadingFormat.value = format
  try {
    await downloadDocument(props.path, format, props.fallbackName)
  }
  finally {
    downloadingFormat.value = null
  }
}
</script>

<template>
  <VTooltip
    location="bottom"
    text="Скачать"
  >
    <template #activator="{ props: tooltipProps }">
      <span
        v-bind="tooltipProps"
        class="d-inline-flex"
      >
        <VMenu
          location="bottom end"
          content-class="entity-form-menu"
        >
          <template #activator="{ props: menuProps }">
            <VBtn
              v-bind="menuProps"
              icon="ri-download-2-line"
              :color="variant === 'ear' ? 'primary' : 'secondary'"
              :variant="variant === 'ear' ? undefined : 'text'"
              :class="variant === 'ear' ? 'entity-form-action-btn' : 'flex-shrink-0 hover-primary'"
              :loading="Boolean(downloadingFormat)"
              aria-label="Скачать"
              :data-onboarding="SHARED_ANCHORS.ear.document"
            />
          </template>
          <VList
            density="compact"
            min-width="180"
          >
            <VListItem
              prepend-icon="ri-file-pdf-2-line"
              title="PDF-документ"
              :disabled="Boolean(downloadingFormat)"
              @click="onDownload('pdf')"
            />
            <VListItem
              prepend-icon="ri-file-word-2-line"
              title="Документ Word"
              :disabled="Boolean(downloadingFormat)"
              @click="onDownload('docx')"
            />
          </VList>
        </VMenu>
      </span>
    </template>
  </VTooltip>
</template>
